import React, { SVGProps } from 'react'

export const EqualHousingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="icon-equalhousing" {...props}>
    <title>equal housing icon</title>
    <g clipPath="url(#a)" fill="#232F3B">
      <path d="M1.115 14V7.082H.01c0-.654.02-1.277-.009-1.899-.016-.324.09-.485.384-.618.827-.375 1.638-.786 2.456-1.18.64-.308 1.28-.611 1.92-.917l2.08-1.001c.656-.315 1.31-.63 1.967-.941A37.67 37.67 0 0 1 9.917.023c.06-.027.155-.032.21-.004.614.32 1.224.646 1.834.973.706.38 1.412.761 2.117 1.143L17.24 3.85c.667.363 1.336.723 2 1.09.065.036.145.118.146.179.01.728.006 1.455.006 2.21H18.13v6.67H1.115V14Zm14.872-2.085c.005-.067.01-.11.01-.152 0-1.99-.001-3.978.004-5.967 0-.178-.088-.263-.225-.337-.894-.488-1.784-.981-2.68-1.465-.882-.476-1.776-.929-2.648-1.42-.329-.186-.605-.193-.934-.019-.454.24-.93.438-1.394.66-.835.402-1.666.809-2.5 1.211-.7.338-1.399.682-2.108 1.003-.261.118-.36.263-.356.565.018 1.867.009 3.734.009 5.601v.32h12.822Z" />
      <path d="M12.743 7.84H6.326V5.78h6.416V7.84ZM6.315 10.64V8.595h6.433v2.043H6.316Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h19.395v14H0z" />
      </clipPath>
    </defs>
  </svg>
)
